module.exports = __webpack_public_path__ + "img/BPM.0b8d993d.gif";